export const styles = {
  checkbox: {
    width: 20,
    height: 20,
    display: "flex",
    backgroundColor: "events.whiteTertiary",
    borderRadius: "4px",
    border: "1px solid",
    borderColor: "events.grayTertiary",
  },
  checkboxIcon: {
    width: 22,
    height: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    backgroundColor: "events.blueSecondary",
  },
};
